<template>
  <div class="log-table-wrapper">
    <table class="log-table" aria-label="Log entries">
      <thead>
        <tr>
          <th class="log-table__header">Level</th>
          <th class="log-table__header">Timestamp</th>
          <th class="log-table__header">Message</th>
        </tr>
      </thead>
      <tbody>
        <slot />
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.log-table-wrapper {
  @apply border border-zinc-200 dark:border-zinc-700 rounded-10 overflow-hidden;
}

.log-table {
  @apply w-full border-collapse;
}

.log-table__header {
  @apply px-2.5 py-2 text-left text-sm font-bold text-zinc-900 dark:text-zinc-100 bg-slate-100 dark:bg-zinc-700 border-b border-zinc-200 dark:border-zinc-700;
}
</style>
